// TermsPage — renders docs/terms.md as a public, no-auth page.
// Route: /terms (public, outside RequireAuth)
import content from '../../../docs/terms.md?raw';
import { Footer } from '../components/Footer';

export function TermsPage() {
  return (
    <div className="yg-prose-page">
      <div className="yg-prose-wrap">
        <span className="yg-prose-effective">Legal document</span>
        <h1>Terms of Service</h1>
        <pre className="yg-prose-content">{content}</pre>
        <Footer />
      </div>
    </div>
  );
}
